// extracted by mini-css-extract-plugin
module.exports = {"notfound":"notfound_notfound__1FiWT","notfound404":"notfound_notfound404__1wUql","notfound-404":"notfound_notfound-404__zo_j6"};